module.exports = __webpack_public_path__ + "img/img-32.972c4be3.png";